/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Can_We_HelpInputs */

const en_how_can_we_help = /** @type {(inputs: How_Can_We_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How can we help?`)
};

const nl_how_can_we_help = /** @type {(inputs: How_Can_We_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe kunnen we helpen?`)
};

/**
* | output |
* | --- |
* | "How can we help?" |
*
* @param {How_Can_We_HelpInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const how_can_we_help = /** @type {((inputs?: How_Can_We_HelpInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Can_We_HelpInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_how_can_we_help(inputs)
	return en_how_can_we_help(inputs)
});